import { useEffect } from 'react';
import '../css/ProjectPage.css';
import ContactSection from './ContactSection';

function ProjectPage({ label, title, paragraphs, footer, source, links = [] }) {
    const projectLinks = source
        ? [{ label: 'View source', href: source }, ...links]
        : links;

    useEffect(() => {
        const previousTitle = document.title;
        document.title = `${label.split(' · ')[0]} · Aditya Patel`;
        return () => {
            document.title = previousTitle;
        };
    }, [label]);

    return (
        <div className="project-page-shell">
            <main className="project-page">
                <a className="project-page-back" href="/">Aditya Patel</a>
                <div className="project-page-copy">
                    <p className="project-page-label">{label}</p>
                    <h1>{title}</h1>
                    {paragraphs.map(({ id, content }) => <p key={id}>{content}</p>)}
                    {projectLinks.length > 0 && (
                        <div className="project-page-links">
                            {projectLinks.map(({ label: linkLabel, href }) => (
                                <a
                                    key={href}
                                    href={href}
                                    target={href.startsWith('http') ? '_blank' : undefined}
                                    rel={href.startsWith('http') ? 'noreferrer' : undefined}
                                >
                                    {linkLabel} {href.startsWith('http') ? '↗' : '→'}
                                </a>
                            ))}
                        </div>
                    )}
                </div>
                <p className="project-page-footer">{footer}</p>
            </main>
            <ContactSection />
        </div>
    );
}

export default ProjectPage;
